import { Box, Text } from "@chakra-ui/react";

type BookSlotCardProps = {
  selected?: boolean;
  onClick?: () => void;
};
const BookSlotCard: React.FC<BookSlotCardProps> = ({
  onClick,
  selected = false,
}) => {
  return (
    <Box
      role="group"
      p={4}
      bg={"white"}
      cursor="pointer"
      borderRadius={"12px"}
      border={"1px solid #23428D"}
      transition="all 300ms"
      onClick={onClick}
      display="flex"
      alignItems="center"
      experimental_spaceX={"14px"}
    >
      <Box fontSize={"xl"} color="#363636">
        <i className="ri-calendar-line"></i>
      </Box>
      <Box>
        <Text
          fontSize="xs"
          lineHeight="12px"
          fontFamily="Cairo"
          fontWeight="500"
          color="#363636"
        >
          Date
        </Text>
        <Text
          fontSize="15px"
          lineHeight="24px"
          fontFamily="Cairo"
          fontWeight="600"
          color={selected ? "#23428D" : "#363636"}
          _groupHover={{ color: "#23428D" }}
        >
          Sun Nov 21st 10:00am
        </Text>
      </Box>
    </Box>
  );
};

export { BookSlotCard };
